<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import Modal from '@/components/common/layout/Modal.vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import MarkdownContent from '@/components/common/layout/MarkdownContent.vue'
import { useNewsStore } from '@/stores/useNewsStore'
import { NEWS_TYPE_BADGES, NEWS_TYPE_LABELS } from '@/utils/newsDisplay'
import { formatDateForDisplay } from '@/utils/dateUtils'
import oidcAuth from '@/auth/oidcAuth'

const router = useRouter()
const newsStore = useNewsStore()

const isOpen = computed(() => newsStore.showNewsModal)
const news = computed(() => newsStore.unseenItems)

const formatDate = (iso: string) => formatDateForDisplay(new Date(iso))

const closeModal = () => {
  newsStore.closeNewsModal()
}

const viewFeed = () => {
  closeModal()
  router.push('/news')
}
</script>

<template>
  <Modal v-if="oidcAuth.isAuthenticated" :show-modal="isOpen" @close="closeModal" title="Quoi de neuf ?">
    <template #content>
      <div class="space-y-4 max-h-[60vh] overflow-y-auto p-1">
        <div v-for="item in news" :key="item.uuid" class="card bg-base-100 shadow-xs">
          <div class="card-body p-4">
            <div class="flex items-start gap-3">
              <div class="badge badge-lg shrink-0" :class="NEWS_TYPE_BADGES[item.type]">
                {{ NEWS_TYPE_LABELS[item.type] }}
              </div>
              <div class="flex-1 min-w-0">
                <div class="flex items-baseline justify-between gap-2">
                  <h4 class="font-medium text-base">{{ item.title }}</h4>
                  <span class="text-xs opacity-60 shrink-0">{{ formatDate(item.publishedAt) }}</span>
                </div>
                <MarkdownContent :content="item.body" class="mt-1 opacity-80" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between w-full">
        <ButtonDaisy variant="ghost" @click="viewFeed" text="Voir le fil d'actualité"> </ButtonDaisy>
        <ButtonDaisy variant="primary" @click="closeModal" text="J'ai compris"> </ButtonDaisy>
      </div>
    </template>
  </Modal>
</template>
